import { useEffect, useState } from "react";

import AdminOnboardingBottomArea from "../AdminOnboardingBottomArea";
import LandingPageNavArea from "../LandingPageComponents/LandingPageNavArea";
import KnowledgeBaseUserManagement from "./KnowledgeBaseUserManagement";
import FeatureSwitch from "./FeatureSwitch";
import KnowledgeBaseVideoLibrary from "./KnowledgeBaseVideoLibrary";
import KnowledgeBaseCourseManager from "./KnowledgeBaseCourseManager";
import KnowledgeBaseEventManager from "./KnowledgeBaseEventManager";
import styles from "./KnowledgeBaseBackground.module.css";

function KnowledgeBaseBackground(): JSX.Element {
  const [screenDisplay, setScreenDisplay] = useState("userManagement");

  // const [searchTerm, setSearchTerm] = useState("");

  // const [searchIndex, setSearchIndex] = useState(0)
  // const [searchResultLength, setSearchResultLength] = useState(0)

  const getViewArea = () => {
    const element = document.getElementById("toFrame4KnowledgeBase");
    element?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // const getView4FirstOccuranceArea = () => {
  //     const element = document.getElementById(`${searchTerm}testsearch`);
  //     element?.scrollIntoView({ behavior: "smooth", block: "center" });
  //   };

  // useEffect(()=>{
  //   getView4FirstOccuranceArea()
  // },[searchTerm])

  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    window.addEventListener("scroll", function () {
      console.log("Y-Position: ", window.scrollY);
      setScrollY(window.scrollY);

      //     if (window.scrollY > MAX_SCROLL_Y) {
      //   window.scrollTo({
      //     top: MAX_SCROLL_Y,
      //     behavior: 'instant' // Prevents stuttering or smooth-scroll loops
      //   });
      // }
    });
  });

  // const updateSearchIndex=(action:string)=>{
  //   setSearchIndex(action==="add"?searchIndex<searchResultLength?searchIndex+1:searchIndex: searchIndex>1?searchIndex-1:searchIndex)

  // }

  return (
    <div className={styles.frame} id="toFrame4KnowledgeBase">
      <LandingPageNavArea showDesktopMenu />
      {/* sticky left-0 top-[72px]   */}
      <div className="w-full z-10 sticky left-0 top-[72px]   h-auto py-10 phone:px-4 bg-[#4856DD] flex flex-col justify-center items-center">
        <h1 className="w-full text-center text-[30px] phone:text-[20px] text-white font-bold">
          How-To Guides
        </h1>
        <h2 className="w-full text-center text-[18px] phone:text-[14px] text-white">
          Our centralized repository of information designed to help our users
          find answers, solve problems, and understand processes efficiently.
        </h2>

        {/* 
        <div className="w-[550px] phone:w-[90%] h-[48px] rounded-lg bg-[#EEE7F8] mt-[24px] phone:mt-6 px-4 py-2 flex">
          <img src="/icons/search.svg" width={24} height={24} alt="" />
          <input
            type="text"
            id="searchInput"
            placeholder="Search for answers"
            className="w-[70%]  text-[#555555] px-2 h-full bg-[#EEE7F8] outline-none  "
            onChange={({ target }) => {
              setSearchTerm(target.value);
            }}
          />
          <div className="h-full flex items-center px-1 border  border-[#979797] rounded-lg text-[16px] ">
            <span className="text-[#555555]">{searchIndex}</span> / <span className="text-[#979797]">{searchResultLength}</span>
          </div>

          <div className="h-full flex items-center gap-[12px] ml-3">
            <div className="w-[32px] h-[28px] rounded-md flex items-center justify-center bg-white cursor-pointer"
             onClick={()=>{
              updateSearchIndex("back")
             }}
            >
              <img src="/icons/arrow-up.svg" width={16} height={16} />
            </div>
            <div className="w-[32px] h-[28px] rounded-md flex items-center justify-center bg-white/50 cursor-pointer"
              onClick={()=>{
              updateSearchIndex("add")
             }}
            >
              <img src="/icons/arrow-up.svg" width={16} height={16} className="rotate-180" />
            </div>
          </div>
        </div> */}
      </div>
      <div
        className={`w-fit z-1 text-[16px] absolute sticky  left-[11%] text-[#4856DD] flex items-center gap-x-2 cursor-pointer px-4 py-2 rounded-xl shadow-md border  ${
          scrollY > 310 ? "visible" : "invisible"
        } ${scrollY > 310 && scrollY < 10520 ? "top-[700px]" : "top-[600px]"}`}
      >
        {/* 9020   "top-[200px]" */}
        <img
          src="/icons/arrow-up-long.svg"
          height={16}
          width={16}
          alt="arrow"
        />{" "}
        <span
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
          onClick={() => {
            getViewArea();
          }}
        >
          Back to top
        </span>
      </div>

      <div className={styles.contentArea} id="scrollcontentArea">
        <div className={styles.leftPane}>
          <FeatureSwitch setScreenDisplay={setScreenDisplay} />
        </div>
        <div className={styles.rightPane} id="componentContainer">
          {screenDisplay === "userManagement" ? (
            <KnowledgeBaseUserManagement
            // searchIndex={searchIndex}
            // searchTerm={searchTerm}
            // setSearchIndex={setSearchIndex}
            // setSearchResultLength = {setSearchResultLength}
            />
          ) : screenDisplay === "videoLibrary" ? (
            <KnowledgeBaseVideoLibrary
            //  searchIndex={searchIndex}
            // searchTerm={searchTerm}
            // setSearchIndex={setSearchIndex}
            // setSearchResultLength = {setSearchResultLength}
            />
          ) : screenDisplay === "courseManager" ? (
            <KnowledgeBaseCourseManager
            // searchTerm={searchTerm}
            // searchIndex={searchIndex}
            // setSearchIndex={setSearchIndex}
            // setSearchResultLength = {setSearchResultLength}
            />
          ) : screenDisplay === "eventManager" ? (
            <KnowledgeBaseEventManager
            // searchIndex={searchIndex}
            // searchTerm={searchTerm}
            // setSearchIndex={setSearchIndex}
            // setSearchResultLength = {setSearchResultLength}
            />
          ) : null}
        </div>
      </div>

      <AdminOnboardingBottomArea />
    </div>
  );
}

export default KnowledgeBaseBackground;
